import React, {Component} from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import LeftMenu from './LeftMenu/LeftMenu';
import RightMenu from './RightMenu/RightMenu'
import './App.css';
import {translations} from "./translations";
import Simulator from "./Simulator/Simulator";

export const LanguageContext = React.createContext('pl');

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 'pl',
            resetSimulator: false,
        };

        this.updateLanguage = language => {
            window.history.pushState(
                null, 
                null, 
                window.location.origin + '/' + language + '/' + (window.location.pathname.split('/')[2] || '')
            );
            this.setState({language: language});
        };

        this.setResetSimulator = resetSimulator => {
            localStorage.setItem('is_ozobot_running', '0');
            this.setState({resetSimulator: resetSimulator});
        }
    }

    getLanguageFromUrl() {
        const availableLanguages = ['pl', 'en', 'ua'];
        const languageFromUrl = window.location.pathname.split('/')[1];
        this.setState({language: availableLanguages.includes(languageFromUrl) ? languageFromUrl : 'pl'})
    }

    componentDidMount() {
        this.getLanguageFromUrl();
        if(!['pl', 'en', 'ua'].includes(window.location.pathname.split('/')[1])) {
            this.updateLanguage('pl');
        }
    }

    componentDidUpdate(_prevProps, prevState) {
        if(this.state.language !== prevState.language) {
            this.getLanguageFromUrl();
        }
    }

    render() {
        return (
            <LanguageContext.Provider value={{
                language: translations[this.state.language],
                updateLanguage: this.updateLanguage
            }}
            >
                <BrowserRouter>
                    <div className="App">
                        <LeftMenu/>
                        <Route path="*/:hash?" render={props => <Simulator {...props}
                                                                           resetSimulator={this.state.resetSimulator}
                                                                           setResetSimulator={this.setResetSimulator}/>}/>
                        <RightMenu setResetSimulator={this.setResetSimulator}/>
                    </div>
                </BrowserRouter>
            </LanguageContext.Provider>
        );
    }
}

export default connect(
    state => ({}),
    {}
)(App);



// WEBPACK FOOTER //
// ./src/App.js